__webpack_require__.p = "/27f0bc68888b0590eaa9a4cf6a831c5ea8f931bf/assets/enzo/frontend-core/js/";